import { render, staticRenderFns } from "./ReservationItems.vue?vue&type=template&id=9eb1cc34"
import script from "./ReservationItems.vue?vue&type=script&lang=js"
export * from "./ReservationItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports